import { PropsWithChildren } from "react";

import { Button, IconName } from "capitalrx-components-2.0/lib/general";

import "./styles.scss";

interface NavigateButtonProps {
  onClick: () => void;
  icon?: IconName
}

export const NavigateButton = ({ onClick, icon = "arrow-left", children }: PropsWithChildren<NavigateButtonProps>) => {
  return (
    <Button icon={icon} onClick={onClick} appearance="text" className="navigate-button">{children}</Button>
  );
};
